import {Component, Inject, OnInit} from '@angular/core';
import {CasinoBetsService} from "../../../services/casino/casino-bets.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'app-baccarat1',
  templateUrl: './baccarat1.component.html',
  styleUrls: ['./baccarat1.component.css']
})
export class Baccarat1ResultComponent implements OnInit {

  details: any = {};
  player1: any = [];
  player2: any = [];
  tables: any = [];
  winner: any = '';
  cards: any = '';
  casino_bets: any = [];
  filter_bets: any = [];
  totalbets: number = 0;
  totalAmount: number = 0;
  result_baccarat:any = [];
  winner_pair:any = [];
  big_small:any= [];
  playerCards:any=[];
  bankerCards:any=[];
  win:any = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private casinoBetsService: CasinoBetsService, private router: Router, public dialogRef: MatDialogRef<any>, private fb: FormBuilder, private userService: UserService, private toasterService: ToastrService) {

  }

  ngOnInit(): void {
    console.log('data form',this.data);
      this.dialogRef.updateSize('100%',);
      if(!this.data.acc_state){
        this.getBaccarat1Details();
        }else{
          this.getCasinoResultonMarketId();
        }
      this.getCasinoBetsByMarketID();
  }

  getCasinoResultonMarketId(){
    this.casinoBetsService.getCasinoResultonMarketId(this.data.mid).subscribe((res:any)=>{
      if(res.length>0){
      const renamedObject = {
        ...res[0],          // Copy all existing properties
        desc: res[0].description, // Rename description to desc
        cards: res[0].result // Rename result to cards
      };
      console.log("renamedObject",renamedObject);
      this.extractResultFromData(renamedObject)
    }
    })
  }

  getBaccarat1Details() {
      this.casinoBetsService.getTeenPattiDetails(this.data.mid).subscribe((res: any) => {
          if (res.success) {
              this.details = res.data;
              console.log('xxx--------->', this.details);
              // this.getResults(this.details[0]);
              this.extractResultFromData(this.details[0])
          }else{
            const renamedObject = {
              ...this.data.stored_data,          // Copy all existing properties
              desc: this.data.stored_data.description, // Rename description to desc
              cards: this.data.stored_data.result // Rename result to cards
            };
            this.extractResultFromData(renamedObject)
          }
      });
  }

  private getResults(data: any) {
      const [player1, player2, tables] = this.divideIntoArrays(data.cards);
      this.player1 = player1;
      this.player2 = player2;
      this.tables = tables;
      this.winner = data.win;
      this.cards = this.getFirstCharacters(data.cards);
  }

  private divideIntoArrays(playerString: string) {
      // Split the string by comma
      const players = playerString.split(",");

      // Initialize empty arrays
      const player1 = [];
      const player2 = [];
      const tables = [];

      // Loop through players, assigning first two to player1, second two to player2, and remaining to table
      for (let i = 0; i < players.length; i++) {
          if (i < 2) {
              player1.push(players[i]);
          } else if (i < 4) {
              player2.push(players[i]);
          } else {
              tables.push(players[i]);
          }
      }

      // Return an object containing the arrays
      return [player1, player2, tables];
  }

  private getFirstCharacters(inputString: string) {
      const gameArray = inputString.split(',');
      const result = gameArray.map(game => game.charAt(0));
      return result.join(' ');
  }

  getCasinoBetsByMarketID() {
      this.casinoBetsService.getCasinoBetsByOnlyMarketId(this.data.mid).subscribe((res: any) => {
          console.log('filter_bets data', res);
          this.casino_bets = res;
          this.filter_bets = this.casino_bets;
          this.totalbets = this.casino_bets.length;
          this.totalAmount = this.casino_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
      });
  }

  private extractResultFromData(result: any) {
    console.log('result-->',result);
    if (result.cards.length > 0) {
      let desc = result.desc;
      this.winner = desc;
      this.win = result.win;
      let cards = result.cards;
      // Split the card string into an array
      const cardList = cards.split(",");

      // Distribute cards alternately between Player and Banker
      let playerCards = [];
      let bankerCards = [];

      for (let i = 0; i < cardList.length; i++) {
        if (i % 2 === 0) {
          playerCards.push(cardList[i]);
        } else {
          bankerCards.push(cardList[i]);
        }
      }

      // After distribution, filter out invalid cards (cards without a valid suit)
      const validPlayerCards = playerCards.filter((card) =>
        card.match(/^[0-9JQKA]+[A-Z]{2}$/)
      );
      const validBankerCards = bankerCards.filter((card) =>
        card.match(/^[0-9JQKA]+[A-Z]{2}$/)
      );

      // Helper function to extract card value and suit
      const getCardDetails = (card:any) => {
        const suit = card.slice(-2); // Last two characters represent the suit
        let value;
        if (card.length === 4) {
          value = card.slice(0, 2); // First two characters are the value
        } else {
          value = card.slice(0, 1); // First character is the value
        }
        return { value, suit };
      };

      let playerCard1, playerCard2, bankerCard1, bankerCard2;

      if (validPlayerCards.length >= 2) {
        [playerCard1, playerCard2] = validPlayerCards.map(getCardDetails);

        // Check for Player Pair
        if (playerCard1.value === playerCard2.value) {
          this.winner_pair.push("Player Pair");
        }
      }

      if (validBankerCards.length >= 2) {
        [bankerCard1, bankerCard2] = validBankerCards.map(getCardDetails);

        // Check for Banker Pair
        if (bankerCard1.value === bankerCard2.value) {
          this.winner_pair.push("Banker Pair");
        }
      }

      // Check for Big (total number of cards is 5 or 6)
      const totalCards = validPlayerCards.length + validBankerCards.length;
      console.log('total cards',totalCards);
      if (totalCards === 5 || totalCards === 6) {
        this.big_small.push("Big");
      }

      // Check for Small (total number of cards is 4)
      if (totalCards === 4) {
        this.big_small.push("Small");
      }

      // Check for Perfect Pair
      if (
        (playerCard1 &&
          playerCard2 &&
          playerCard1.value === playerCard2.value &&
          playerCard1.suit === playerCard2.suit) ||
        (bankerCard1 &&
          bankerCard2 &&
          bankerCard1.value === bankerCard2.value &&
          bankerCard1.suit === bankerCard2.suit)
      ) {
        this.result_baccarat.push("Perfect Pair");
      }

      // Check for Either Pair
      if (
        (playerCard1 &&
          playerCard2 &&
          playerCard1.value === playerCard2.value) ||
        (bankerCard1 &&
          bankerCard2 &&
          bankerCard1.value === bankerCard2.value)
      ) {
        this.result_baccarat.push("Either Pair");
      }
     
      this.playerCards = playerCards.filter(item => item !== '1');;
      this.playerCards = this.playerCards.reverse();
      this.bankerCards = bankerCards.filter(item => item !== '1');;
      this.result_baccarat = this.result_baccarat.map((name:any) => `'${name.trim()}'`);

      this.result_baccarat = this.result_baccarat.join(",");
      console.log(`player cards: ${playerCards}`);
      console.log(`banker cards: ${bankerCards}`);
      console.log(`winner_pair: ${this.winner_pair}`);
      console.log(`big_small: ${this.big_small}`);
      console.log(`result_baccarat Cards: ${this.result_baccarat}`);
    }
  }


  filterBetsByType(event: any) {
      const filterType = (event.target as HTMLInputElement).value;
      console.log('filterType', filterType);
      if (filterType === 'all') {
          this.filter_bets = this.casino_bets;
      } else if (filterType === 'deleted') {
          this.filter_bets = this.casino_bets.filter((bet: any) => bet.from === "deleted");
      } else if (filterType === 'Back') {
          this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Back");
      }
      if (filterType === 'Lay') {
          this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Lay");
      }
      this.totalbets = this.filter_bets.length;
      this.totalAmount = this.filter_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
  }

  closeDialog() {
      this.dialogRef.close();
  }

  dismiss() {
      this.dialogRef.close();
  }

}
